import gql from "graphql-tag";

export const INVITE_MANAGER = gql`
  mutation inviteManager($input: inviteManagerInput) {
    inviteManager(input: $input) {
      email
    }
  }
`;
